import { Box, useMediaQuery, useTheme } from '@mui/material'
import { LoginButton, SignupButton } from './AuthButtons'
import { usePageTitle } from '@/utils/hooks/usePageTitle'

export default function LoginSignup() {
  usePageTitle('Login')

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: isMobile ? '100%' : '50%',
        margin: '0 auto',
        height: '80vh',
      }}
    >
      <img
        src="/Fundsorter-h-black800px.png"
        alt="Fundsorter Logo"
        width={isMobile ? '70%' : '50%'}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '100%' : '70%',
          alignItems: 'center',
          mt: 5,
          gap: 2,
        }}
      >
<LoginButton />
        <SignupButton />
      </Box>
    </Box>
  )
}
